"use client";
import { env } from "@/env";
import useEvents from "@app/_hooks/useEvents";
import useTranslate from "@app/_hooks/useTranslate";
import CartIcon from "@app/_icons/CartIcon/CartIcon";
import Badge from "@components/Badge/Badge";
import { useCartActions, useCartState } from "@context/cartContext";
import WishlistButton from "@features/account/components/wishlist/WishlistButton";
import AuthButton from "@features/auth/components/AuthButton";
import { Button } from "@ui/button";

const Actions = () => {
  const t = useTranslate();
  const { viewCart } = useEvents();
  const { cart } = useCartState();
  const { showCart } = useCartActions();

  const numItemsInCart = cart?.items
    ?.filter(
      (item) =>
        item?.partNo !== `${env.NEXT_PUBLIC_NSHIFT_DYNAMIC_FREIGHT_PARTNO}`,
    )
    ?.reduce((total, item) => total + (item?.quantity || 0), 0);

  const handleOnClick = () => {
    showCart();
    if (cart) viewCart(cart);
  };

  return (
    <div className="flex items-center gap-1">
      <AuthButton className="hidden md:flex" />
      <WishlistButton />
      <Button
        size="auto"
        variant="link"
        onClick={handleOnClick}
        data-testid="cart-icon-button"
        title={t("yourCart")}
        aria-label={t("yourCart")}
      >
        <Badge badgeContent={numItemsInCart}>
          <CartIcon />
        </Badge>
      </Button>
    </div>
  );
};

export default Actions;
